module.exports = __webpack_public_path__ + "4704c0718de11ca1f314c0ef6f51546e.svg";